export default {
    'name': 'concepts',
    'label': 'CAS.Concepts',
    'getComponent': () => import('./Concepts.vue'),
    'tabIndex': 100,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/cas/concepts',
};
